import {useQuery, UseQueryResult} from '@tanstack/react-query';
import ProblemDetailsError from '../ProblemDetailsError.ts';
import {useCreateAuthenticatedFetch} from '../useCreateAuthenticatedFetch.ts';
import baseUrl from '../baseUrl.ts';
import {handleResponse} from '../handleResponse.ts';

export const useGetPendingApprovalsCount = (
    isAuthenticated: boolean,
    isAdmin: boolean
): UseQueryResult<number, Error | ProblemDetailsError> => {
    const authenticatedFetch = useCreateAuthenticatedFetch();

    return useQuery({
        queryKey: ['pending-approvals-count', isAuthenticated, isAdmin],
        queryFn: async () => {
            const response = await authenticatedFetch(
                `${baseUrl}/api/admin/pending-approvals-count`
            );
            return handleResponse(response);
        },
        enabled: isAuthenticated && isAdmin,
        refetchInterval: 15 * 60 * 1000 // Refetch every 15 minutes
    });
};
